import { ActionState } from '../../../state-utils/action-state/action-state.model';
import { ActionStateCreator } from '../../../state-utils/action-state/action-state.creator';
import {
  AuthAction,
  REQUEST_PASSWORD_RESET,
  REQUEST_PASSWORD_RESET_FAIL,
  REQUEST_PASSWORD_RESET_SUCCESS,
  RESET_PASSWORD,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD_SUCCESS,
  USER_LOGIN,
  USER_LOGIN_FAIL,
  USER_LOGIN_SUCCESS,
  VERIFY_EMAIL_SUCCESS
} from './auth.actions';

export interface AuthState {
  userCredentials: {
    email?: string;
    redirectUri: string;
  };
  loginError: string | null;
  requestPasswordResetActionState: ActionState;
  resetPasswordActionState: ActionState;
  emailVerifiedInCurrentSession: boolean;
  isLoading: boolean;
}

export const initialState: AuthState = {
  loginError: null,
  userCredentials: {
    email: '',
    redirectUri: ''
  },
  requestPasswordResetActionState: ActionStateCreator.create(),
  resetPasswordActionState: ActionStateCreator.create(),
  emailVerifiedInCurrentSession: false,
  isLoading: false
};

export function reducer(state = initialState, action: AuthAction): AuthState {
  switch (action.type) {
    case USER_LOGIN: {
      const { userCredentials } = action;
      return {
        ...state,
        isLoading: true,
        userCredentials
      };
    }

    case USER_LOGIN_SUCCESS: {
      return {
        ...state,
        loginError: null,
        isLoading: false
      };
    }

    case USER_LOGIN_FAIL: {
      return {
        ...state,
        isLoading: false,
        loginError: action.loginError
      };
    }

    case REQUEST_PASSWORD_RESET: {
      return {
        ...state,
        requestPasswordResetActionState: ActionStateCreator.onStart()
      };
    }

    case REQUEST_PASSWORD_RESET_FAIL: {
      return {
        ...state,
        requestPasswordResetActionState: ActionStateCreator.onError(
          action.error
        )
      };
    }

    case REQUEST_PASSWORD_RESET_SUCCESS: {
      return {
        ...state,
        requestPasswordResetActionState: ActionStateCreator.onSuccess()
      };
    }

    case RESET_PASSWORD: {
      return {
        ...state,
        resetPasswordActionState: ActionStateCreator.onStart()
      };
    }

    case RESET_PASSWORD_FAIL: {
      return {
        ...state,
        resetPasswordActionState: ActionStateCreator.onError(action.error)
      };
    }

    case RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        resetPasswordActionState: ActionStateCreator.onSuccess()
      };
    }

    case VERIFY_EMAIL_SUCCESS: {
      return {
        ...state,
        emailVerifiedInCurrentSession: true
      };
    }

    default: {
      return state;
    }
  }
}
